import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const DataJurnal = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showTanggalModal, setShowTanggalModal] = useState(false);
  const [showJurnalModal, setShowJurnalModal] = useState(false);

  const [selectedJurnal, setSelectedJurnal] = useState(null);
  const [tanggal, setTanggal] = useState("");
  const [items, setItems] = useState([]);

  /* ================= FETCH ================= */
  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/jurnal-kepsek`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setData(res.data);
    } catch {
      alert("Gagal mengambil data jurnal");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= EDIT TANGGAL ================= */
  const openEditTanggal = (jurnal) => {
    setSelectedJurnal(jurnal);
    setTanggal(jurnal.tanggal.split("T")[0]);
    setShowTanggalModal(true);
  };

  const saveTanggal = async () => {
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/jurnal-kepsek/${selectedJurnal._id}/tanggal`,
        { tanggal },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setShowTanggalModal(false);
      fetchData();
    } catch (err) {
      alert(err.response?.data?.msg || "Tanggal sudah digunakan");
    }
  };

  /* ================= EDIT JURNAL ================= */
  const openEditJurnal = (jurnal) => {
    setSelectedJurnal(jurnal);

    // ✅ CLONE agar tidak mengubah state asli & tidak sentuh tanggal
    const cloned = jurnal.jurnal.map((item) => ({
      judul: item.judul || "",
      tujuan: item.tujuan || "",
      kegiatan: item.kegiatan || "",
      keterangan: item.keterangan || "",
    }));

    setItems(cloned);
    setShowJurnalModal(true);
  };

  const handleItemChange = (i, field, value) => {
    const updated = [...items];
    updated[i] = { ...updated[i], [field]: value };
    setItems(updated);
  };

  const saveJurnal = async () => {
    if (items.length === 0) {
      alert("Jurnal tidak boleh kosong");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/jurnal-kepsek/item/${selectedJurnal._id}`,
        { jurnal: items }, // ⬅️ HANYA jurnal
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setShowJurnalModal(false);
      fetchData();
    } catch (err) {
      alert(err.response?.data?.msg || "Gagal update jurnal");
    }
  };

  const deleteJurnal = async (id) => {
    const confirm = window.confirm(
      "Yakin ingin menghapus jurnal pada tanggal ini?"
    );
    if (!confirm) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/jurnal-kepsek/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchData();
    } catch (err) {
      alert(err.response?.data?.msg || "Gagal menghapus jurnal");
    }
  };

  if (loading) return <p className="p-4">Loading...</p>;

  return (
    <div className="p-4 max-w-6xl mx-auto">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-2 sm:gap-0">
        {/* Judul */}
        <h1 className="text-lg sm:text-xl font-semibold">
          Jurnal Kepala Sekolah
        </h1>

        {/* Tombol */}
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto mt-2 sm:mt-0">
          <Link
            to={`/addjurnal/${id}`}
            className="w-full sm:w-auto bg-blue-600 text-white px-4 py-2 rounded text-sm text-center hover:bg-blue-700"
          >
            + Tambah Jurnal
          </Link>
          <Link
            to={`/downloadjurnal/${id}`}
            className="w-full sm:w-auto bg-blue-600 text-white px-4 py-2 rounded text-sm text-center hover:bg-blue-700"
          >
            Download Jurnal
          </Link>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {data.map((jurnal) => (
          <div
            key={jurnal._id}
            className="border rounded-lg p-4 bg-white shadow"
          >
            <p className="text-sm text-gray-500 mb-2">
              Tanggal:{" "}
              <span className="font-medium">
                {new Date(jurnal.tanggal).toLocaleDateString("id-ID")}
              </span>
            </p>

            <ul className="list-disc pl-4 text-sm mb-3">
              {jurnal.jurnal.map((item, i) => (
                <li key={i}>
                  <span className="font-semibold">{item.judul}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row sm:justify-between gap-2 sm:gap-0 items-start sm:items-center">
              {/* Tombol Edit */}
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <button
                  onClick={() => openEditJurnal(jurnal)}
                  className="w-full sm:w-auto px-3 py-2 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Edit Jurnal
                </button>

                <button
                  onClick={() => openEditTanggal(jurnal)}
                  className="w-full sm:w-auto px-3 py-2 text-sm bg-orange-500 text-white rounded hover:bg-orange-600"
                >
                  Edit Tanggal
                </button>
              </div>

              {/* Tombol Hapus */}
              <div className="w-full sm:w-auto mt-2 sm:mt-0">
                <button
                  onClick={() => deleteJurnal(jurnal._id)}
                  className="w-full sm:w-auto px-3 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Hapus
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ================= MODAL EDIT TANGGAL ================= */}
      {showTanggalModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded w-[90%] max-w-sm">
            <h2 className="font-semibold mb-3">Edit Tanggal</h2>

            <input
              type="date"
              className="border rounded px-3 py-2 w-full mb-4"
              value={tanggal}
              onChange={(e) => setTanggal(e.target.value)}
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowTanggalModal(false)}
                className="px-3 py-1 bg-gray-400 text-white rounded"
              >
                Batal
              </button>
              <button
                onClick={saveTanggal}
                className="px-3 py-1 bg-blue-600 text-white rounded"
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= MODAL EDIT JURNAL ================= */}
      {showJurnalModal && (
        <div className="fixed inset-0 bg-black/40 overflow-y-auto z-50">
          <div className="bg-white p-4 rounded max-w-3xl mx-auto my-10">
            <h2 className="font-semibold mb-4">Edit Jurnal</h2>

            {items.map((item, i) => (
              <div key={i} className="border p-3 rounded mb-3">
                <p className="font-bold">judul </p>
                <input
                  className="border px-2 py-1 rounded w-full mb-2"
                  maxLength={100}
                  value={item.judul}
                  onChange={(e) => handleItemChange(i, "judul", e.target.value)}
                />
                <p className="font-bold">Tujuan </p>
                <textarea
                  className="border px-2 py-1 rounded w-full mb-2"
                  maxLength={200}
                  value={item.tujuan}
                  onChange={(e) =>
                    handleItemChange(i, "tujuan", e.target.value)
                  }
                />
                <p className="font-bold">Kegiatan </p>
                <textarea
                  className="border px-2 py-1 rounded w-full mb-2"
                  maxLength={200}
                  value={item.kegiatan}
                  onChange={(e) =>
                    handleItemChange(i, "kegiatan", e.target.value)
                  }
                />
                <p className="font-bold">Keterangan </p>
                <textarea
                  className="border px-2 py-1 rounded w-full"
                  maxLength={200}
                  value={item.keterangan}
                  onChange={(e) =>
                    handleItemChange(i, "keterangan", e.target.value)
                  }
                />
              </div>
            ))}

            <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4">
              <button
                onClick={() => setShowJurnalModal(false)}
                className="w-full sm:w-auto px-3 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
              >
                Batal
              </button>
              <button
                onClick={saveJurnal}
                className="w-full sm:w-auto px-3 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataJurnal;
